import React from 'react'
import { BANKING_BOTTOM_CONTENT, SOFTWARE_COURSE_PAGE_4, SOFTWARE_DETAILS_PAGE_4, SOFTWARE_HERO_PAGE_4 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { SOFTWARE_ACCORDIAN_4 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const SoftwarePage_4 = () => {
  return (
    <div className='outlet-render'>
        <CourseAsideHero  {...SOFTWARE_HERO_PAGE_4}/>
     <CoursesAside {...SOFTWARE_COURSE_PAGE_4}/>
     <CourseCard {...SOFTWARE_DETAILS_PAGE_4}/>
     <Accordian {...SOFTWARE_ACCORDIAN_4}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default SoftwarePage_4